import moment from 'moment';

export const sort = (items: any, key: any, date: any = false) =>
  items.sort((a: any, b: any) =>
    date ? moment(a[key]).diff(moment(b[key])) : a[key] - b[key]
  );
